import { render, staticRenderFns } from "./BottomFooter.vue?vue&type=template&id=52f74588&scoped=true"
import script from "./BottomFooter.vue?vue&type=script&lang=js"
export * from "./BottomFooter.vue?vue&type=script&lang=js"
import style0 from "./BottomFooter.vue?vue&type=style&index=0&id=52f74588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f74588",
  null
  
)

export default component.exports